import { render, staticRenderFns } from "./IntroductionWelcome.vue?vue&type=template&id=6740f6a6&scoped=true&"
import script from "./IntroductionWelcome.vue?vue&type=script&lang=js&"
export * from "./IntroductionWelcome.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionWelcome.vue?vue&type=style&index=0&id=6740f6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740f6a6",
  null
  
)

export default component.exports